module.exports = __webpack_public_path__ + "img/mobile__logo.74627fe0.svg";